import styled from 'styled-components';
import { colorSchema as coloSchemaBase } from '@ontruck/orc';

const baseFontSize = '1.2rem';

export const themeBaseOverwrite = {
  colorSchema: {
    primary: coloSchemaBase.primary500,
    secondary: coloSchemaBase.primary100,
  },
  textSizes: {
    M: baseFontSize,
  },
  weight: {
    medium: '500',
  },
};

export const themeComponentBaseOverwrite = {
  SegmentedButton: {
    sizes: {
      M: {
        height: '3.2rem',
        padding: '.8rem',
      },
    },
  },
  Button: {
    sizes: {
      XS: {
        borderSize: '.1rem',
      },
      M: {
        height: '3.2rem',
        fontSize: baseFontSize,
        borderRadius: '.4rem',
        borderSize: '.1rem',
      },
    },
  },
  Field: {
    sizes: {
      M: {
        height: '3.2rem',
        padding: {
          base: {
            H: '.8rem',
            V: '.8rem',
          },
          // innerLabel: {
          //   top: size16,
          //   bottom: size2
          // },
          // asideText: {
          //   left: size24,
          //   right: size32
          // }
        },
        fontSize: {
          input: '1.2rem',
          label: '1rem',
        },
      },
    },
  },
  Link: {
    sizes: {
      M: {
        fontSize: baseFontSize,
      },
    },
  },
  RadioCheckbox: {
    sizes: {
      M: {
        height: '3.2rem',
      },
      XLsmall: {
        fontSize: '1.2rem',
        height: '3.2rem',
      },
    },
  },
  Tooltip: {
    sizes: {
      M: {
        fontSize: '1.2rem',
      },
      L: {
        fontSize: '1.4rem',
      },
    },
  },
  Tag: {
    skins: {
      priority: {
        bg: coloSchemaBase.primary100,
        fg: coloSchemaBase.primary900,
      },
    },
  },
};

export const colorSchema = (color) => (props) =>
  props && props.theme && props.theme.base.colorSchema[color];
export const textSizes = (size) => (props) => props.theme.base.textSizes[size];
export const gridSizes = (size) => (props) =>
  props && props.theme && props.theme.base.gridSizes[size];
export const withStyles =
  (...args) =>
  (WrappedComponent) =>
    styled(WrappedComponent)(...args);

export const reactSelectStyles = {
  container: (base) => ({
    ...base,
    height: '100%',
    width: '100%',
    boxShadow: 'none',
  }),
  control: (base) => ({
    ...base,
    borderColor: '#94A6B8',
    borderRadius: '0px',
    minHeight: 32,
    height: '100%',
    '&:hover': { borderColor: '#94A6B8' },
    boxShadow: 'none',
  }),
  multiValueLabel: (base) => ({
    ...base,
    fontWeight: 'bolder',
    fontSize: '100%',
    color: '#3b4f63',
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none',
  }),
  // MultiValue margin increased slect height on option selected.
  multiValue: (base) => ({
    ...base,
    margin: '1px 2px',
  }),
  dropdownIndicator: (base, props) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
    display: props?.selectProps?.hideDropdownIndicator ? 'none' : base.display,
  }),
  placeholder: (base) => ({
    ...base,
    color: '#94A6B8',
    margin: 0,
  }),
  input: (base) => ({
    ...base,
    marginLeft: 0,
  }),
  clearIndicator: (base, props) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: props?.selectProps?.hideDropdownIndicator ? base.paddingRight : 0,
    paddingLeft: 0,
    color: '#94A6B8',
  }),
  // Avoids Stop-stage cells form J cards to overlap the menu.
  menu: (base) => ({
    ...base,
    zIndex: 10,
  }),
};
